import { Component, OnInit, ComponentFactoryResolver, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

import { FormBuildComponent } from '../form-build/form-build.component';
import { FormHostDirective } from '../../directive/form-host.directive';
import { FormBuildService } from '../../service/form-build.service';

@Component({
  selector: 'app-form-child',
  templateUrl: './form-child.component.html',
  styleUrls: ['./form-child.component.scss']
})
export class FormChildComponent extends FormBuildComponent implements OnInit {

  @Input()
  name: string;

  @Input()
  noID: boolean = false;

  @Input()
  showHud: boolean = true;

  @Input()
  visible: boolean = true;

  @Input()
  data: { key: string, show: boolean, form: FormGroup };

  @Output()
  onComplete: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  onClose: EventEmitter<string> = new EventEmitter<string>();

  constructor(public formBuildService: FormBuildService) {
    super(formBuildService);
  }

  ngOnInit() {
    this.form = new FormGroup({});
    this.parent.addControl(this.name, this.form);
    this.formBuildService.build(this.key, this.noID, this.formHost.viewContainerRef, this.form);
  }

  complete() {
    this.onComplete.emit(this.key);
    this.visible = false;
  }
  close() {
    this.clear();
    this.onClose.emit(this.key);
    this.visible = false;
  }

  toggleVisible(){
    this.visible = ! this.visible;
  }

}



// WEBPACK FOOTER //
// ./src/app/form/core/component/form-child/form-child.component.ts